import {
    IProjectReleaseLotDto, IProjectReleaseLotMigrationSourceSelectionGroupDto,
    LotContractTypeEnumId
} from '@classictechsolutions/hubapi-transpiled-enums';
import { IDocumentEntityMappedItem } from '@app/logic/documents';
import { IReleaseStageMappedItem } from '@app/logic/release-stages/interfaces/i.release-stage.mapped';

export interface IData {
    lot?: IProjectReleaseLotDto;
    migrationLots?: IProjectReleaseLotMigrationSourceSelectionGroupDto[];
    projectReleaseId: number;
    allowedLotContractTypes?: LotContractTypeEnumId[];
    projectReleaseStageMappedItem: IReleaseStageMappedItem;
}

export interface ILotAdd {
    id: number;
    name: string;
    units: ILotAdd[];
    documents: IDocumentEntityMappedItem[];
}

export interface IDocAssignmentRow {
    sourceLotId: number;
    sourceLotNumber?: number;
    sourceJobNumber?: string;
    documentEntityId: number;
    documentType?: string;
    documentId: number;
    documentName: string;
    destinationLotNumber?: number;
}

export interface INewLotSummary {
    lotNumber: number;
    lotType: string;
}

export enum LotMigratorStepIndex {
    SelectSourceLots = 0,
    SourceConfig = 1,
    ReviewLotDetails = 2,
    SelectDocuments = 3,
    AssignDocumentDestinations = 4,
    ReviewChanges = 5
}

export const LOT_MIGRATOR_ERROR_MESSAGE = {
    invalidLotDetails:
        'Cannot proceed to this step because the lot details are invalid.',
    invalidDocumentAssignments:
        'Cannot proceed to this step until all selected documents have a destination lot.'
} as const;
